<template>
  <base-layout :do-skip-header="false">
    <template #main>
      <h1 class='text-3xl md:text-4xl font-bold my-8'>
        The Program of the EBM 2026 Portugal
      </h1>

      <modal v-show="showCaptLunchModal && spotsLeft(selectedModalDay)>0 && user && !alreadyRegistered" header="Captain's Dinner Registration" affirmative-button-label="Register"
        @submit="submitCaptLunchReg(selectedModalDay)"
        @cancel="showCaptLunchModal = false"
        :disabled="spotsLeft(selectedModalDay) === captainsDinnerMax[selectedModalDay]">
        <template #body>
          <div>
            <dl class="mt-4 px-4 sm:px-2 mr-1">
              <div class="flex items-center gap-3 border-b">
                <!-- Image hidden on small screens -->
                <img src="https://www.europeanbrokermeeting.com/images/icon_captains.png" 
                    alt="Captain's Dinner Icon" 
                    class="hidden sm:block w-20 h-20 -mt-5">

                <div class="py-2 sm:px-2 text-justify">
                  <strong class="text-gray-700">
                    There are currently {{ spotsLeft(selectedModalDay) }} of maximum {{ captainsDinnerMax[selectedModalDay] }} spots available.
                  </strong>
                  <br>
                  <div v-if="selectedModalDay == 0" class="mt-1">
                    <em>Your registration will be reviewed and you will receive an email notification once it is confirmed.</em>
                    <br><br>
                  </div>
                </div>
              </div>

              <p class="mt-2 text-justify">
                <strong>Maximum 2 people per company, sales managers and company owners only!</strong><br><br>
                Yes, I want to register for the Captain's Dinner on Thursday October 21, 2026 from 19:00 - 22:00.
              </p>
            </dl>
          </div>

        </template>
      </modal>

      <modal v-show="showCaptLunchSuccess" header="Captain's Dinner Registration" affirmative-button-label="Close" @submit="showCaptLunchSuccess = false" :doSkipCancel="true">
        <template #body>
          <div>
            <dl class="mt-4 mb-4 sm:-ml-6 sm:-mr-6">
              <div class="py-2 sm:px-6">
                <strong>Your registration has been recorded and will be reviewed.</strong><br>
                Once your registration has been approved, you will receive an automatic email notification.
              </div>
            </dl>
          </div>
        </template>
      </modal>

      <modal v-show="showCaptLunchFail" header="Captain's Dinner Registration" affirmative-button-label="Close" @submit="showCaptLunchFail = false" :doSkipCancel="true">
        <template #body>
          <div>
            <dl class="mt-4 sm:-ml-6 sm:-mr-6">
              <div class="py-2 sm:px-6 text-center text-lg">
                <strong>You are already registered.</strong><br>
              </div>
            </dl>
          </div>
        </template>
      </modal>

      
      <modal v-show="showCompanyLimitReached" header="Captain's Dinner Registration" affirmative-button-label="Close" @submit="showCompanyLimitReached = false" :doSkipCancel="true">
        <template #body>
          <div>
            <dl class="mt-4 sm:-ml-6 sm:-mr-6">
              <div class="py-2 sm:px-6 text-center text-lg">
                <strong>Two of your colleagues have already been approved for the Captain's Dinner.</strong><br>
              </div>
            </dl>
          </div>
        </template>
      </modal>


            <div class="">
        <div id="app" class="">
          <!-- Main card with red background and modern design -->
          <div class="bg-gradient-to-br from-red-600 via-red-700 to-red-800 rounded-3xl p-6 md:p-8 shadow-2xl shadow-red-900/30 border border-red-400/20">
            
            <!-- Decorative elements for social media poster feel -->
            <div class="relative">
              <!-- Subtle pattern overlay -->
              <div class="absolute inset-0 opacity-5 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px] pointer-events-none rounded-3xl"></div>
              
              <!-- Top accent -->
              <div class="flex flex-row-reverse items-start mb-6 relative">
                <div class="flex items-center gap-3">
                  <div 
                    v-for="(day, index) in program" 
                    :key="index"
                    class="w-3 h-3 rounded-full transition-all duration-300"
                    :class="currentTab === index ? 'bg-white/50' : 'bg-white/20'"
                  ></div>
                </div>
              </div>

              <!-- Tabs -->
              <div class="flex justify-center gap-3 md:gap-4 mb-8 relative">
                <button
                  v-for="(day, index) in program"
                  :key="index"
                  @click="currentTab = index"
                  class="rounded-2xl px-5 py-3 md:px-7 md:py-4 transition-all duration-300 border-2 min-w-[80px] text-center"
                  :class="currentTab === index 
                    ? 'bg-white text-red-600 border-white shadow-2xl shadow-black/20 scale-105' 
                    : 'bg-white/20 text-white border-white/30 hover:bg-white/30 backdrop-blur-sm'"
                >
                  <div class="text-xs uppercase tracking-wider opacity-80 font-medium">
                    {{ ['Wed', 'Thu', 'Fri'][index] }}
                  </div>
                  <div class="text-2xl md:text-3xl font-bold leading-tight">
                    {{ ['21', '22', '23'][index] }}
                  </div>
                  <div class="text-[10px] md:text-xs uppercase tracking-wider opacity-70">
                    October
                  </div>
                </button>
              </div>

              <!-- Timeline -->
              <div class="space-y-4 relative">
                <!-- Decorative line -->
                <div class="absolute left-8 top-0 bottom-0 w-0.5 bg-white/10 hidden sm:block"></div>
                
                <div
                  v-for="(event, index) in program[currentTab].events"
                  :key="index"
                  class="relative"
                >
                  <!-- Card -->
                  <div class="rounded-2xl bg-white backdrop-blur-sm p-4 md:p-5 border border-white/30 shadow-xl shadow-black/10 transition-all">
                    <div class="flex gap-4 md:gap-5 items-stretch">
                      <!-- Icon -->
                      <div class="flex h-16 w-16 md:h-20 md:w-20 flex-shrink-0 items-center justify-center rounded-2xl bg-red-50/80 border border-red-100/50">
                        <img
                          :src="event.icon"
                          class="w-10 h-10 md:w-12 md:h-12 object-contain"
                          alt="icon"
                        />
                      </div>
                      
                      <!-- Content - will now match icon height -->
                      <div class="flex-1 min-w-0">
                        <div class="flex flex-col sm:flex-row sm:justify-between gap-2 items-start h-full">
                          <div class="min-w-0">
                            <h3 class="text-sm md:text-base font-bold text-gray-800 leading-tight">
                              <router-link
                                v-if="event.route"
                                :to="event.route"
                                class="text-red-700 hover:underline"
                              >
                                {{ event.title }}
                              </router-link>
                              <span v-else>
                                {{ event.title }}
                              </span>
                            </h3>
                            <p class="text-xs md:text-sm text-gray-500 mt-1 font-medium">
                              {{ event.timeStart }} – {{ event.timeEnd }}
                            </p>
                            <p
                              v-if="event.location"
                              class="flex items-start gap-1.5 text-xs md:text-sm text-gray-500 mt-1.5 leading-snug"
                            >
                              <svg
                                class="w-3.5 h-3.5 md:w-4 md:h-4 text-red-600 flex-shrink-0 mt-0.5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.273 1.765 11.842 11.842 0 00.976.544l.062.029.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                              <span>{{ event.location }}</span>
                            </p>
                          </div>
                          
                          <span class="hidden sm:inline-flex items-center justify-center rounded-full bg-red-100 text-red-700 px-3 py-1.5 text-xs md:text-sm font-bold whitespace-nowrap">
                            {{ Math.round((new Date(event.metaEnd) - new Date(event.metaStart)) / 3600000) }} hrs
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div id="regInfo" class="text-lg leading-7 text-gray-700 mt-12 mb-8 space-y-8 bg-white/60 px-10 py-14 shadow-xl shadow-indigo-900/5 backdrop-blur">
        <img src="https://www.thebrokersite.com/images//banners/it4kids-donation-40k.png" alt="IT4Kids Donation 40k" class="block mx-auto">

      </div>

      <div id="regInfo" class="text-lg leading-7 text-gray-700 mt-12 mb-8 space-y-8 bg-white/60 px-10 py-14 shadow-xl shadow-indigo-900/5 backdrop-blur">
        <h3 class="text-2xl font-semibold tracking-tight text-indigo-900 mb-4">The European Broker Meeting supports IT4Kids!</h3>
        <p>
          <a href="https://www.it4kids.com/en/home-en/" target="_blank" rel="noopener" class="text-red-700">IT4Kids</a> collects depreciated hardware from companies and donates its value (on behalf of the donor) to projects of charities dedicated to providing structural sports opportunities for children who otherwise wouldn’t have them due to financial or physical challenges.
          <br><br>
          <center>
          <a href="https://www.it4kids.com/en/home-en/" target="_blank" rel="noopener" class="text-red-700">
            <img src="https://www.europeanbrokermeeting.com/images/IT4Kids-logo-PNG.png" style="width: 250px;" />
          </a>
          </center>
        </p>
        <!-- <p>
          Rooms at the Clayton Hotel Burlington Road are available starting at <strong>&euro;249</strong> per room per night and can be booked through <a href="https://bookings.claytonhotels.com/offer/burlington-road/21stEuropeanBrokerMeeting" target="_blank" rel="noopener" class="text-red-700 break-words">https://bookings.claytonhotels.com/offer/burlington-road/21stEuropeanBrokerMeeting</a>
        </p> -->
      </div>      
    </template>
  </base-layout>

</template>

<script>
import _ from "lodash";
import BaseLayout from "../components/BaseLayout.vue";
import Modal from "../components/modal.vue";
import { mapState } from "vuex";

export default {
  name: "Register",
  components: {
    BaseLayout,
    Modal,
  },
  data() {
    return {
      showCaptLunchModal: false,
      showCaptLunchSuccess: false,
      showCaptLunchFail: false,
      showCompanyLimitReached: false,
      showPresentation0: false,
      showPresentation1: false,
      selectedModalDay: null,
      captainsDinnerMax: [250, 250],
      captainsLunchConsumed: [5, 8],
      spotsAvail: [0, 0],
      regStatus: null,
      days: ['2025-11-05', '2025-11-06', '2025-11-07'],
      currentTab: 0,
      captainsDinnerLimit: 250,
      alreadyRegistered: false,
      reachedCompanyLimit: false,
      isDoneFetchingCaptainsDinnerDetails: false,
      captainsDinnerRegistrationStatus: 1,
      program: [
        {
          'events': [
            {
              'timeStart':'10:00',
              'timeEnd':'20:00',
              'metaStart':'2026-10-21T10:00',
              'metaEnd':'2026-10-21T20:00',
              'title':'Early registration at the Tivoli Marina Vilamoura Algarve Resort',
              'location':'Lobby, Blue Corner, Level: 0',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_register.png',
            },

            {
              'timeStart':'18:00',
              'timeEnd':'20:00',
              'metaStart':'2026-10-21T18:00',
              'metaEnd':'2026-10-21T20:00',
              'title':'Welcome drinks for registered attendees',
              'location':'PUROBEACH',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_drinks.png',
            },
          ]
        },
        {
          'events': [
            {
              'timeStart':'09:00',
              'timeEnd':'18:00',
              'metaStart':'2026-10-22T09:00',
              'metaEnd':'2026-10-22T18:00',
              'title':'Registration',
              'location':'Lobby, Blue Corner, Level: 0',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_register.png',
            },
            {
              'timeStart':'10:00',
              'timeEnd':'18:00',
              'metaStart':'2026-10-22T10:00',
              'metaEnd':'2026-10-22T18:00',
              'title':'One-on-One meetings',
              'location':'FENIX Congress Center, Level: 1 of Congress Center, access on Level 0 from the hotel lobby',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_meetings.png',
            },
            {
              'timeStart':'10:00',
              'timeEnd':'17:00',
              'metaStart':'2026-10-22T10:00',
              'metaEnd':'2026-10-22T17:00',
              'title':'ITAD Association Tech Talks (view schedule)',
              'route':'/techtalk',
              'location':'Pégaso rooms: VII + VIII / Ground Floor Congress Center',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_techtalk.png',
            },
            {
              'timeStart':'12:00',
              'timeEnd':'14:00',
              'metaStart':'2026-10-22T12:00',
              'metaEnd':'2026-10-22T14:00',
              'title':'Lunch at the Tivoli Marina Vilamoura Algarve Resort',
              'location':'Voyage Restaurant, Level: 00',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_tivoli.png',
            },
            {
              'timeStart':'19:00',
              'timeEnd':'22:00',
              'metaStart':'2026-10-22T19:00',
              'metaEnd':'2026-10-22T22:00',
              'title':'Open Air Dinner Party with Live Entertainment at Tivoli Vilamoura ',
              'location':'Pool and Gardens, Level: 00',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_dinner.png',
            },
          ]
        },
        {
          'events': [
            {
              'timeStart':'10:00',
              'timeEnd':'18:00',
              'metaStart':'2026-10-23T10:00',
              'metaEnd':'2026-10-23T17:00',
              'title':'One-on-One meetings',
              'location':'FENIX Congress Center, Level: 1 of Congress Center, access on Level 0 from the hotel lobby',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_meetings.png',
            },
            {
              'timeStart':'12:00',
              'timeEnd':'14:00',
              'metaStart':'2026-10-23T12:00',
              'metaEnd':'2026-10-23T14:00',
              'title':'Lunch at the Tivoli Marina Vilamoura Algarve Resort',
              'location':'Voyage Restaurant, Level: 00',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_tivoli.png',
            },
            {
              'timeStart':'20:00',
              'timeEnd':'22:00',
              'metaStart':'2026-10-23T20:00',
              'metaEnd':'2026-10-23T22:00',
              'title':'Dinner & Live Entertainment at Tivoli Vilamoura',
              'location':'Voyage Restaurant, Level: 00',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_dinner.png',
            },
            {
              'timeStart':'22:00',
              'timeEnd':'24:00',
              'metaStart':'2026-10-23T22:00',
              'metaEnd':'2026-10-23T24:00',
              'title':'Official Lakeside After Party, hosted by TheBrokerSite and WDMi, at Tivoli Vilamoura',
              'location':'Lakeside, at Tivoli Vilamoura, Level: 00',
              'icon':'https://www.europeanbrokermeeting.com/images/icon_afterparty.png',
            },
          ]
        },
      ]
    };
  },
  computed: {
    ...mapState(["user"])
  },
  mounted() {
    // if ((this.$route.path === '/program/captain-register') || (this.$route.path === '/program/captain-register/')) {
    //   // Set the current tab and show the modal with the validated value
    //   this.currentTab = 1;
    //   this.showCaptainsLunchModal(0); // Show modal if valid parameter is found
    // }
  },

  async created() {
    this.checkLoginStatus()
    this.fetchCaptainsLunchSlotsTaken()
  },
  watch: {
    user: {
      handler(newVal) {
        if (newVal) {
		      this.fetchCaptainsLunchSlotsTaken()
        }
      },
      deep: true,
      immediate: false
    },
  },
  methods: {
    formatDay(dateStr, type) { // added by Brian to format the date in the scheduler tabs
      const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const dateObj = new Date(dateStr);
      const day = daysOfWeek[dateObj.getDay()];
      const month = months[dateObj.getMonth()];
      const date = dateObj.getDate();

      return `${day} ${month} ${date}`;
    },

    tabClass(index) {
      this.currentTab = String(this.currentTab) // Added by Brian: convert to string, because when using mobile, the value is passed as an integer and the === won't work, results in only displaying the cancelled meetings tab
      if (+index === +this.currentTab) return 'border-red-500 text-red-600 flex whitespace-nowrap border-b-2 py-4 px-1 font-medium'
      return 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700 flex whitespace-nowrap border-b-2 py-4 px-1font-medium';
    },

    showCaptainsLunchModal(dayNumber) {
      this.selectedModalDay = dayNumber
      if(this.alreadyRegistered) {
        this.showCaptLunchFail = true
      } else if(this.reachedCompanyLimit){
        this.showCompanyLimitReached = true
      } else {
        this.showCaptLunchModal = true
      }
    },

    spotsLeft(dayNumber) {
      // calculate the number of captain's lunch slots that are still available
      this.spotsAvail[dayNumber] =  this.captainsDinnerMax[dayNumber] - this.captainsLunchConsumed[dayNumber]
      return this.spotsAvail[dayNumber] !== null && this.spotsAvail[dayNumber] !== undefined && !isNaN(this.spotsAvail[dayNumber])
        ? this.spotsAvail[dayNumber]
        : this.captainsDinnerMax[dayNumber];
    },

    async submitCaptLunchReg(dayNumber) {
      const payload = {
        contactId: this.user.id,
        dayNumber,
      }
      try {
        const response = await this.$http.post("/api/misc/regCaptLunch", payload)
        this.regStatus = response.data

        if (this.regStatus.status === 200) {
          // Success case
          this.showCaptLunchModal = false
          this.showCaptLunchSuccess = true
        } else {
          // Handle other status codes
          this.showCaptLunchModal = false
          this.showCaptLunchFail = true
          console.log('Registration failed with status:', this.regStatus.status)
        }
      } catch (err) {
        this.showCaptLunchModal = false
        this.showCaptLunchFail = true
        console.log(err)
      }
    },

    openASCDIEvent() {
      window.open('https://www.ascdi.com/event/ebm2025/', '_blank', 'noopener,noreferrer');
    },

    async fetchCaptainsLunchSlotsTaken() {
      try {
        const res = await this.$http.get("/api/misc/captLunchSlotsTaken");
        if(res.data.status === 200) {

          const data = res.data
          const registrationStatus = data.registrationStatus

          this.captainsDinnerRegistrationStatus = registrationStatus
          this.captainsLunchConsumed = data.payload
          this.alreadyRegistered = 
            (registrationStatus != null && registrationStatus !== 9) ||
            data.approvedRegistrations.some(r => r.contactId === this.user.id);
        
          if(data.approvedRegistrations.length >= 2) {
            this.reachedCompanyLimit = true
          }
        }
      } catch (err) {
        console.log("err", err)
      } finally {
        this.isDoneFetchingCaptainsDinnerDetails = true;
      }

      if ((this.$route.path === '/program/captain-register') || (this.$route.path === '/program/captain-register/')) {
        this.currentTab = 1;
        this.showCaptainsLunchModal(0);
      }
    },

    checkLoginStatus() {
      const userData = localStorage.getItem('user');
      if (!userData) {
        this.captainsDinnerRegistrationStatus = 0;
      }
    }
  },
};
</script>
